export default {
    getNoteFilter: (state) => state.filter,
    getNoteList: (state) => state.list,
    getNoteResult: (state) => state.result,
    getNoteValidation: (state) => state.validation,
  };